import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import JobList from "../jobs/JobList";
import Notifications from "./Notifications";

class Dashboard extends Component {
  render() {
    const { jobs, auth, notifications } = this.props;
    return (
      <div className="dashboard container">
        <div className="row">
          <div className="col s12 m6">
            <JobList jobs={jobs} />
          </div>
          <div className="col s12 m5 offset-m1">
            <Notifications notifications={notifications} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    jobs: state.firestore.ordered.jobs,
    notifications: state.firestore.ordered.notifications
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: "jobs", orderBy: ["createdAt", "desc"] },
    { collection: "userNotifications", limit: 3, orderBy: ["time", "desc"] }
  ])
)(Dashboard);
